var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.783 15.8755V8.21875H2.2168V15.8755C2.2168 16.5051 2.72719 17.0155 3.3568 17.0155H14.643C15.2726 17.0155 15.783 16.5051 15.783 15.8755Z",
    stroke: "#949A9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0179V8.21875",
    stroke: "#949A9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8917 6.01485V7.07875C16.8917 7.70835 16.3813 8.21875 15.7517 8.21875H2.2484C1.61879 8.21875 1.1084 7.70835 1.1084 7.07875V6.01485C1.1084 5.38525 1.61879 4.87485 2.2484 4.87485H15.7517C16.3813 4.87485 16.8917 5.38525 16.8917 6.01485Z",
    stroke: "#949A9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00025 4.875C9.00025 3.75 7.68775 1.125 5.719 1.125C2.51614 1.125 3.68286 4.875 5.21584 4.875",
    stroke: "#949A9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.875C9 3.75 10.3125 1.125 12.2812 1.125C15.4841 1.125 14.3174 4.875 12.7844 4.875",
    stroke: "#949A9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDarkIcon);
export default __webpack_public_path__ + "static/media/rewardDarkIcon.89a65e7e3986fa9980eef4c0a0e7537e.svg";
export { ForwardRef as ReactComponent };